export type SearchableSelectOption = {
  value: string;
  label: string;
  triggerLabel?: string;
  searchTokens?: string[];
};

export type SearchableSelectLabels = {
  trigger: string;
  cancel: string;
  searchPlaceholder: string;
  searchLabel: string;
  clearSearch: string;
  empty: string;
  shortcuts?: string;
  options?: string;
};

const normalizeSearchableSelectText = (value: string) =>
  value
    .trim()
    .normalize('NFD')
    .replace(/\p{Diacritic}+/gu, '')
    .toLowerCase();

export function matchesSearchableSelectOption(
  option: SearchableSelectOption,
  query: string,
): boolean {
  const normalizedTokens = normalizeSearchableSelectText(query)
    .split(/\s+/u)
    .filter((token) => token.length > 0);

  if (normalizedTokens.length === 0) {
    return true;
  }

  const searchTokens =
    option.searchTokens && option.searchTokens.length > 0
      ? option.searchTokens
      : [option.label, option.triggerLabel ?? option.label, option.value];
  const haystack = searchTokens.map((token) => normalizeSearchableSelectText(token));

  return normalizedTokens.every((token) => haystack.some((value) => value.includes(token)));
}

export function filterSearchableSelectOptions(
  options: SearchableSelectOption[],
  query: string,
): SearchableSelectOption[] {
  return options.filter((option) => matchesSearchableSelectOption(option, query));
}
